import patient from '@/sui/data/sheets/edit/patient'
import bact from '@/sui/data/sheets/edit/bact'
import bounds from '@/sui/data/sheets/edit/bounds'
import notes from '@/sui/data/sheets/edit/notes'
import fields from '@/sui/data/sheets/edit/fields'

import common from '@/sui/data/sheets/edit/notes/common'
import cfg from '@/sui/data/sheets/edit/cfg/diaInfADI'

import assert from '@/sui/tools/assert'

function checkNumericValues (result, sheet) {
  const numericChecks = [
    bounds.height,
    bounds.weight
  ]

  notes.checkNumerics(result, sheet, numericChecks)
}

function checkBacteremias (result, sheet) {
  const bacts = sheet[fields.bactArray]
  const bactsNotes = result[fields.bactArray]
  assert.equals(bacts.length, bactsNotes.length)

  for (let i in bacts) {
    const bactf = bacts[i]
    const notes = bactsNotes[i]
    common.checkBactMicroOrg(notes, bactf, fields.bacteremia)
  }
}

function checkInfections (result, sheet) {
  const kts = sheet[fields.catheterArray]
  const ktsNotes = result[fields.catheterArray]
  assert.equals(kts.length, ktsNotes.length)

  for (let i in kts) {
    const kt = kts[i]
    const note = ktsNotes[i]

    const infections = kt[fields.infections]
    const infectionsNotes = note[fields.infections]
    assert.equals(infections.length, infectionsNotes.length)
    for (let j in infections) {
      const inf = infections[j]
      const infNote = infectionsNotes[j]
      common.checkMicroOrg(infNote, inf, fields.infection, 'Une infection')
    }
  }
}

function checkDates (result, sheet, year) {
  const v2 = year !== 2019
  const y = `${year}`
  const v = v2 ? 'v2' : 'v1'
  const birthdate = notes.dateField(result, sheet, patient.birthdate)
  const entrydate = notes.dateField(result, sheet, cfg.entryDate)
  const firstsuppdate = notes.dateField(result, sheet, cfg.firstSubstn)
  const exitdate = notes.dateField(result, sheet, patient.exitDate)
  const oldest = notes.oldest[y]
  const newest = notes.newest[y]
  const start = notes.start[y]

  const comparisons = [
    { f: oldest, s: birthdate },
    { f: oldest, s: entrydate },
    { f: oldest, s: exitdate },
    { f: oldest, s: firstsuppdate },

    { f: birthdate, s: newest },
    { f: entrydate, s: newest },
    { f: exitdate, s: newest },
    { f: firstsuppdate, s: newest },

    { f: birthdate, s: entrydate },
    { f: birthdate, s: exitdate },
    { f: birthdate, s: firstsuppdate },

    { f: entrydate, s: exitdate },

    { f: start, s: entrydate },

    { f: start, s: exitdate },
    { f: firstsuppdate, s: exitdate }
  ]

  const kts = sheet[fields.catheterArray]
  const ktsNotes = result[fields.catheterArray]
  assert.equals(kts.length, ktsNotes.length)

  for (let i in kts) {
    const kt = kts[i]
    const note = ktsNotes[i]

    const firstusedate = notes.dateField(note, kt, cfg.catheterFirstUse[v])
    const ablationdate = notes.dateField(note, kt, cfg.catheterAblation[v])
    const useenddate = notes.dateField(note, kt, cfg.catheterUseEnding[v])

    comparisons.push(
      { f: oldest, s: firstusedate },
      { f: oldest, s: ablationdate },
      { f: oldest, s: useenddate },
      { f: firstusedate, s: newest },
      { f: ablationdate, s: newest },
      { f: useenddate, s: newest },

      { f: birthdate, s: firstusedate },
      { f: firstusedate, s: ablationdate },
      { f: firstusedate, s: useenddate },
      { f: firstusedate, s: exitdate },

      { f: birthdate, s: ablationdate },
      { f: entrydate, s: ablationdate },
      { f: ablationdate, s: exitdate },

      { f: birthdate, s: useenddate },
      { f: entrydate, s: useenddate },
      { f: useenddate, s: exitdate }
    )

    const infections = kt[fields.infections]
    const infectionsNotes = note[fields.infections]
    assert.equals(infections.length, infectionsNotes.length)
    for (let j in infections) {
      const inf = infections[j]
      const infNote = infectionsNotes[j]
      const infectiondate = notes.dateField(infNote, inf, cfg.infectionDate)
      if (year >= 2025) {
        common.checkEpisodAndEntry(infectiondate, entrydate)
      }

      comparisons.push(
        { f: start, s: infectiondate },
        { f: infectiondate, s: newest },

        { f: birthdate, s: infectiondate },
        { f: infectiondate, s: exitdate }
      )

      if (v2) {
        const diagdate = notes.dateField(infNote, inf, bact.diagDate.v1)
        comparisons.push(
          { f: infectiondate, s: diagdate },
          { f: infectiondate, s: newest },
          { f: oldest, s: infectiondate },
          { f: birthdate, s: diagdate }
        )
      }
    }
  }

  const bacts = sheet[fields.bactArray]
  const bactsNotes = result[fields.bactArray]
  assert.equals(bacts.length, bactsNotes.length)

  for (let i in bacts) {
    const bactf = bacts[i]
    const note = bactsNotes[i]

    const episoddate = notes.dateField(note, bactf, bact.episod)
    if (year >= 2025) {
      common.checkEpisodAndEntry(episoddate, entrydate)
    }

    const insertiondate = notes.dateField(note, bactf, bact.insertionDate[v])
    const enfInsertionDate = notes.dateField(
      note, bactf, bact.enfInsertionDate[v]
    )
    const removaldate = notes.dateField(note, bactf, bact.removalDate[v])
    comparisons.push(
      { f: start, s: episoddate },
      { f: birthdate, s: episoddate },
      { f: episoddate, s: newest },
      { f: episoddate, s: exitdate },

      { f: birthdate, s: insertiondate },
      { f: insertiondate, s: episoddate },
      { f: insertiondate, s: newest },
      { f: insertiondate, s: exitdate },
      { f: insertiondate, s: removaldate },

      { f: birthdate, s: removaldate },
      { f: entrydate, s: removaldate },
      { f: removaldate, s: exitdate },
      { f: removaldate, s: newest },

      { f: birthdate, s: enfInsertionDate },
      { f: enfInsertionDate, s: newest },
      { f: enfInsertionDate, s: exitdate }
    )

    if (year >= 2020) {
      const diagdate = notes.dateField(note, bactf, bact.diagDate.v1)
      comparisons.push(
        { f: episoddate, s: diagdate },
        { f: birthdate, s: diagdate }
      )
    }

    if (year >= 2021) {
      const manipdate = notes.dateField(note, bactf, bact.previousManipDate)
      const enfmanipdate = notes.dateField(
        note, bactf, bact.enfPreviousManipDate
      )
      const beforeEpisod = common.beforeEpisod(
        episoddate.date, note[bact.episod.field]
      )

      comparisons.push(
        { f: birthdate, s: manipdate },
        { f: beforeEpisod, s: manipdate },
        { f: manipdate, s: episoddate },
        { f: insertiondate, s: manipdate },
        { f: manipdate, s: removaldate },
        { f: manipdate, s: exitdate },

        { f: birthdate, s: enfmanipdate },
        { f: beforeEpisod, s: enfmanipdate },
        { f: enfmanipdate, s: episoddate },
        { f: enfInsertionDate, s: enfmanipdate },
        { f: enfmanipdate, s: exitdate }
      )
    }
  }
  notes.compareDates(comparisons)
}

function buildNotes (result, sheet, year, surveillance) {
  checkDates(result, sheet, year)
  checkBacteremias(result, sheet)
  checkInfections(result, sheet)
  checkNumericValues(result, sheet)
  common.checkUfs(result, sheet, 'diaInfADI', surveillance)
}

export default {
  build2019: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2019, surveillance)
    return result
  },

  build2020: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2020, surveillance)
    return result
  },

  build2021: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2021, surveillance)
    return result
  },

  build2022: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2022, surveillance)
    return result
  },

  build2023: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2023, surveillance)
    return result
  },

  build2024: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2024, surveillance)
    return result
  },

  build2025: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2025, surveillance)
    return result
  },

  build2026: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2026, surveillance)
    return result
  }
}
